import { render, staticRenderFns } from "./All_User_Group.vue?vue&type=template&id=3570835e"
import script from "./All_User_Group.vue?vue&type=script&lang=js"
export * from "./All_User_Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports